function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { signIn } from "@common/actions";
import GoogleReCaptcha from "@common/components/GoogleReCaptcha";
import { replaceWith } from "@common/services/helpers";
import request from "@common/services/request";
import { LOGO_SITE_WEB, MANIFEST_NAME, PRODUCT_NAME, REGEX_PHONE } from "@config/constants";
import { Button, Grid, TextField } from "@material-ui/core";
import { isEmpty, isObject, set, some } from "lodash";
import { withSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { SNACKBAR_AUTOHIDE_TIMEOUT, SNACKBAR_VARIANT_ERROR, SNACKBAR_VARIANT_SUCCESS, STATUS_CODE_SUCCESS } from "@config/constants";
var MESSAGE_MAX_LENGTH = 250;
var addFunctionality = function(component) {
    return withSnackbar(connect(function(param) {
        var i18n = param.i18n, userDetails = param.userDetails, appConfig = param.appConfig;
        return {
            i18n: i18n,
            userDetails: userDetails,
            appConfig: appConfig
        };
    }, {
        signIn: signIn
    })(component));
};
var DeleteAccountForm = addFunctionality(function(props) {
    var i18n = props.i18n, _email = props.email, enqueueSnackbar = props.enqueueSnackbar, onSuccess = props.onSuccess, hasEmailField = props.hasEmailField, isLoginForm = props.isLoginForm, signIn = props.signIn;
    var _useState = _sliced_to_array(useState(""), 2), recaptchaToken = _useState[0], setRecaptchaToken = _useState[1];
    var _useState1 = _sliced_to_array(useState({
        password: "",
        phone: "",
        message: "",
        email: email
    }), 2), form = _useState1[0], setForm = _useState1[1];
    var _useState2 = _sliced_to_array(useState({
        phone: "",
        message: "",
        password: "",
        email: ""
    }), 2), formErrors = _useState2[0], setFormErrors = _useState2[1];
    var history = useHistory();
    var email = !isEmpty(_email) ? _email : form.email;
    var handleChange = function(e) {
        var _e_target = e.target, name = _e_target.name, value = _e_target.value;
        setForm(_object_spread_props(_object_spread({}, form), _define_property({}, name, value)));
        setFormErrors(_object_spread_props(_object_spread({}, formErrors), _define_property({}, name, "")));
    };
    var validateForm = function() {
        var errors = {
            phone: "",
            message: "",
            password: "",
            email: ""
        };
        // ! REGEX is negative
        if ((form.phone.match(REGEX_PHONE) || isEmpty(form.phone)) && !isLoginForm) {
            errors.phone = i18n.errors.invalidPhoneNumber;
        }
        if (isEmpty(form.message) && !isLoginForm) {
            errors.message = i18n.errors.noMessage;
        }
        if (isEmpty(form.password)) {
            errors.password = i18n.errors.noPassword;
        }
        if (isEmpty(email)) {
            errors.email = i18n.errors.noEmail;
        }
        setFormErrors(_object_spread({}, errors));
        return errors;
    };
    var handleSubmit = function() {
        var _ref = _async_to_generator(function(e) {
            var errors, _e_error_info, loginResponse, formData, contactResponse;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        errors = validateForm();
                        if (some(errors)) return [
                            2
                        ];
                        if (isLoginForm) {
                            try {
                                signIn({
                                    email: email,
                                    password: form.password,
                                    viewmap: props.appConfig.viewmap,
                                    rememberme: false,
                                    grant_type: "client_credentials"
                                });
                                history.push("/");
                            } catch (e) {
                                ;
                                console.error(e);
                                enqueueSnackbar(((_e_error_info = e.error_info) === null || _e_error_info === void 0 ? void 0 : _e_error_info.description) || i18n.errors.generic, {
                                    variant: SNACKBAR_VARIANT_ERROR,
                                    autoHideDuration: SNACKBAR_AUTOHIDE_TIMEOUT
                                });
                            }
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            request({
                                method: "post",
                                url: "/users/login",
                                data: {
                                    email: email,
                                    password: form.password
                                }
                            }).catch(function(e) {
                                var _e_error_info;
                                enqueueSnackbar(((_e_error_info = e.error_info) === null || _e_error_info === void 0 ? void 0 : _e_error_info.description) || i18n.errors.generic, {
                                    variant: SNACKBAR_VARIANT_ERROR,
                                    autoHideDuration: SNACKBAR_AUTOHIDE_TIMEOUT
                                });
                            })
                        ];
                    case 1:
                        loginResponse = _state.sent();
                        if (isEmpty(loginResponse === null || loginResponse === void 0 ? void 0 : loginResponse.data)) return [
                            2
                        ];
                        formData = new FormData();
                        formData.append("from", email);
                        formData.append("subject", i18n.delete.accountDeletionRequest);
                        formData.append("content", "".concat(i18n.delete.contactPhoneNumber, ": ").concat(form.phone) + "\n" + "".concat(i18n.delete.request, ": ").concat(form.message));
                        formData.append("g-recaptcha-response", recaptchaToken);
                        return [
                            4,
                            request({
                                method: "POST",
                                url: "users/contact",
                                data: formData
                            }).catch(function(e) {
                                var _e_error_info;
                                enqueueSnackbar(((_e_error_info = e.error_info) === null || _e_error_info === void 0 ? void 0 : _e_error_info.description) || i18n.errors.generic, {
                                    variant: SNACKBAR_VARIANT_ERROR,
                                    autoHideDuration: SNACKBAR_AUTOHIDE_TIMEOUT
                                });
                            })
                        ];
                    case 2:
                        contactResponse = _state.sent();
                        if ((contactResponse === null || contactResponse === void 0 ? void 0 : contactResponse.status) !== STATUS_CODE_SUCCESS) return [
                            2
                        ];
                        onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var inputProps = {
        classes: {
            root: "form-input"
        }
    };
    var inputLabelProps = _define_property({
        classes: {
            root: "form-label"
        }
    }, "classes", {
        focused: "form-label-focused"
    });
    var renderFeedbackFields = function() {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(Grid, {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ _jsx(TextField, {
                        name: "phone",
                        label: i18n.delete.contactPhoneNumber,
                        helperText: i18n.delete.whyWeNeedYourPhoneNumber,
                        fullWidth: true,
                        variant: "outlined",
                        color: "secondary",
                        InputProps: inputProps,
                        onChange: handleChange,
                        error: !!formErrors.phone,
                        FormHelperTextProps: {
                            classes: {
                                root: "helper-text"
                            }
                        },
                        InputLabelProps: inputLabelProps
                    })
                }),
                /*#__PURE__*/ _jsx(Grid, {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ _jsx(TextField, {
                        id: "tell-us-why",
                        name: "message",
                        label: i18n.delete.pleaseTellUs,
                        fullWidth: true,
                        variant: "outlined",
                        color: "secondary",
                        autoComplete: "off",
                        InputProps: _object_spread_props(_object_spread({}, inputProps), {
                            multiline: true,
                            rows: 10,
                            inputProps: {
                                maxLength: MESSAGE_MAX_LENGTH
                            }
                        }),
                        onChange: handleChange,
                        error: !!formErrors.message,
                        InputLabelProps: inputLabelProps
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ _jsx("form", {
        onSubmit: handleSubmit,
        className: "delete-account-form",
        children: /*#__PURE__*/ _jsxs(Grid, {
            container: true,
            spacing: 2,
            className: "delete-account-form-grid",
            children: [
                /*#__PURE__*/ _jsx(Grid, {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ _jsx("span", {
                        className: "form-title",
                        children: replaceWith(i18n.delete.pleaseFillOutForm, MANIFEST_NAME)
                    })
                }),
                !isLoginForm && renderFeedbackFields(),
                !hasEmailField && /*#__PURE__*/ _jsx(Grid, {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ _jsx(TextField, {
                        name: "email",
                        type: "email",
                        label: i18n.delete.enterEmail,
                        fullWidth: true,
                        variant: "outlined",
                        color: "secondary",
                        InputProps: inputProps,
                        onChange: handleChange,
                        error: !!formErrors.email,
                        InputLabelProps: inputLabelProps
                    })
                }),
                /*#__PURE__*/ _jsx(Grid, {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ _jsx(TextField, {
                        name: "password",
                        type: "password",
                        label: i18n.delete.enterCurrentPassword,
                        fullWidth: true,
                        variant: "outlined",
                        color: "secondary",
                        InputProps: inputProps,
                        onChange: handleChange,
                        error: !!formErrors.password,
                        InputLabelProps: inputLabelProps
                    })
                }),
                /*#__PURE__*/ _jsx(Grid, {
                    item: true,
                    xs: 6,
                    children: /*#__PURE__*/ _jsx(GoogleReCaptcha, {
                        action: "write_to_us",
                        onChange: setRecaptchaToken
                    })
                }),
                /*#__PURE__*/ _jsx(Grid, {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ _jsx(Button, {
                        type: "submit",
                        variant: "outlined",
                        color: "secondary",
                        classes: {
                            label: "ux-button-label"
                        },
                        className: "button full-width",
                        children: i18n.delete.delete
                    })
                }),
                /*#__PURE__*/ _jsx(Grid, {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ _jsx(Button, {
                        classes: {
                            label: "ux-button-label primary"
                        },
                        className: "button full-width",
                        onClick: function() {
                            return history.push("/");
                        },
                        children: i18n.delete.cancel
                    })
                })
            ]
        })
    });
});
export var DeleteAccountPage = function(props) {
    var i18n = props.i18n, userDetails = props.userDetails, isLoginForm = props.isLoginForm;
    var location = useLocation();
    var history = useHistory();
    var _useState = _sliced_to_array(useState(""), 2), email = _useState[0], setEmail = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), isSuccess = _useState1[0], setIsSuccess = _useState1[1];
    var _useState2 = _sliced_to_array(useState(true), 2), isEmailPrefilled = _useState2[0], setIsEmailPrefilled = _useState2[1];
    useEffect(function() {
        var params = new URLSearchParams(location.search);
        var primaryEmail = params.get("email");
        var email = params.get("email") || (userDetails === null || userDetails === void 0 ? void 0 : userDetails.email);
        if (isEmpty(primaryEmail) && isObject(userDetails) && isEmpty(userDetails === null || userDetails === void 0 ? void 0 : userDetails.email)) {
            setIsEmailPrefilled(false);
        }
        setEmail(email);
    }, [
        location,
        history,
        userDetails
    ]);
    var renderDeleteContent = function() {
        return /*#__PURE__*/ _jsxs("div", {
            className: "delete-account-wrapper sorry-to-see-you-go",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "column delete-account-header",
                    children: [
                        /*#__PURE__*/ _jsx("img", {
                            className: "logo",
                            src: LOGO_SITE_WEB,
                            alt: "logo"
                        }),
                        /*#__PURE__*/ _jsx("h1", {
                            className: "title",
                            children: i18n.delete.deleteAccount
                        }),
                        /*#__PURE__*/ _jsx("h2", {
                            className: "email",
                            children: email
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(DeleteAccountForm, {
                    email: email,
                    onSuccess: function() {
                        return setIsSuccess(true);
                    },
                    hasEmailField: isEmailPrefilled && !isLoginForm,
                    isLoginForm: isLoginForm
                })
            ]
        });
    };
    var renderSuccess = function() {
        return /*#__PURE__*/ _jsx("div", {
            className: "delete-account-success-wrapper sorry-to-see-you-go",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "column delete-account-success",
                children: [
                    /*#__PURE__*/ _jsx("img", {
                        className: "logo",
                        src: LOGO_SITE_WEB,
                        alt: "logo"
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "column text-wrapper",
                        children: [
                            /*#__PURE__*/ _jsx("h1", {
                                className: "title",
                                children: i18n.delete.sorryToSeeYouGo
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "message",
                                children: i18n.delete.yourRequestHasBeenSent
                            })
                        ]
                    })
                ]
            })
        });
    };
    return /*#__PURE__*/ _jsx("div", {
        className: "delete-account-page ".concat(PRODUCT_NAME),
        children: isSuccess ? renderSuccess() : renderDeleteContent()
    });
};
var mapStateToProps = function(param) {
    var i18n = param.i18n, userDetails = param.userDetails;
    return {
        i18n: i18n,
        userDetails: userDetails
    };
};
var mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(DeleteAccountPage);
